import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(
    public http: HttpClient
  ) { }

    getPartners(): Observable<any> {
      return this.http.get('./assets/mycomcde.json').pipe(
        map((res) => {
          return res['comcde'];
        })
      );
    }

    public async  getComcde() {
      return await this.getPartners().toPromise().then(res => res);
    }
}
